<div class="login-page">
  <div class="login-panel">
    <div class="login-logo">
      <img src="assets/site_logo_white.svg" alt="GioSite" />
    </div>
    <div class="login-body">
      <form #form="ngForm" name="form" (ngSubmit)="doLogin()" novalidate>
        <div class="login-field">
          <input nz-input placeholder="Usuario" autocomplete="off" pKeyFilter="email" name="email" type="email" id="input-email" [(ngModel)]="email" [disabled]="loading" />
        </div>
        <div class="login-field">
          <input
            nz-input
            placeholder="Contraseña"
            autocomplete="current-password"
            name="password"
            type="password"
            id="input-password"
            [(ngModel)]="password"
            [disabled]="loading"
          />
        </div>
        <div class="login-field">
          <span class="login-field-icon" aria-hidden="true"><i class="fa fa-globe"></i></span>
          <input nz-input placeholder="dominio-gioweb" name="dominio" type="text" id="input-dominio" [(ngModel)]="dominio" [disabled]="loading" />
        </div>
        <button nz-button nzType="primary" nzBlock class="login-submit" type="submit" [disabled]="loading">
          @if (!loading) {
          <span>Acceder</span>
          } @if (loading) {
          <span><i class="fas fa-circle-notch fa-spin fa-lg fa-2x"></i></span>
          }
        </button>
      </form>
      <div class="login-language">
        <app-language-selector (changeLanguage)="onChangeLanguage($event)"></app-language-selector>
      </div>
    </div>
  </div>
  <app-footerbar></app-footerbar>
</div>
<div class="login-background"></div>
